import { BaseClient } from 'src/common-services/clients/base-client'
import { AMDemographicsLocationByVisitorsHomeRequest } from 'src/common-services/types/alphamap'
import { CommonTradeAreaSection } from 'src/common-services/types/trade-area-types'

export class DemographicsClient extends BaseClient {
  getDemographicsLocationByVisitorsHome(
    request: AMDemographicsLocationByVisitorsHomeRequest
  ): Promise<CommonTradeAreaSection> {
    return this.call<CommonTradeAreaSection>(`/v2/demographics/location/${request.id}/by-visitors-home`, 'POST', {
      data: request,
    })
  }
}
